const hasSymbol = typeof Symbol === 'function' && Symbol.for;

const diffSymbol = hasSymbol ? Symbol('diff') : 'diff';

const QUOTE_SYS_PROP = {
  '-1': {
    index: -1,
    name: '创建者',
    type: 'user',
    multiple: false,
  },
  '-2': {
    index: -2,
    name: '创建时间',
    type: 'datetime',
  },
  '-3': {
    index: -3,
    name: '标题',
    type: 'text',
  },
  '-5': {
    index: -5,
    name: '负责人',
    type: 'user',
    multiple: false,
  },
  '-6': {
    index: -6,
    name: '参与者',
    type: 'user',
    multiple: true,
  },
  '-7': {
    index: -7,
    name: '开始时间',
    type: 'datetime',
  },
  '-8': {
    index: -8,
    name: '结束时间',
    type: 'datetime',
  },
  '-1000': {
    index: -1000,
    name: '状态',
    type: 'enum',
  },
};

module.exports = { diffSymbol, QUOTE_SYS_PROP };
